import { render, staticRenderFns } from "./CollectionDetails.vue?vue&type=template&id=05159e21&scoped=true&"
import script from "./CollectionDetails.vue?vue&type=script&lang=js&"
export * from "./CollectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDetails.vue?vue&type=style&index=0&id=05159e21&prod&lang=scss&scoped=true&"
import style1 from "./CollectionDetails.vue?vue&type=style&index=1&id=05159e21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05159e21",
  null
  
)

export default component.exports